import { apiClient, __pickBy } from '../../utils';
import { uploadMedias, handleError } from '../';
import {
  UPLOAD_MEDIA_FOREIGN_TYPES,
  POST_CHAIN_NEW_MEDIAS_UPLOADED_SUCCESSFULLY,
  POST_EDITED_SUCCESSFULLY,
} from '../../config';
import { toSitePost } from './toSitePost';
import { toPost } from './toPost';
import { removePost } from './remove';
import { Observable } from 'rxjs';

export const editPost = ({
  pci,
  tl,
  tx,
  titles,
  texts,
  si,
  lt,
  ln,
  psi,
  files,
  modelFile,
  price,
  filters,
  inventory,
  inventoryFilters,
  siteService,
  editInUneed,
  editInPersonalSite,
  addToUneed,
  removeFromUneed,
  addToPersonalSite,
  removeFromPersonalSite,
  newMedias,
  siteId,
  userSiteFilters,
}) => {
  return new Observable(async (subscriber) => {
    try {
      const payload = {
        ...(pci ? { pci } : {}),
        ...(tl ? { tl } : {}),
        ...(tx ? { tx } : {}),
        ...(titles ? { titles } : {}),
        ...(texts ? { texts } : {}),
        ...(lt ? { lt } : {}),
        ...(ln ? { ln } : {}),
        ...(si ? { si } : {}),
        ...(price ? { price } : {}),
        ...(filters ? { filters } : {}),
        ...(inventory ? { inventory } : {}),
        ...(inventoryFilters ? { inventoryFilters } : {}),
      };
      const editIn = {
        ...(editInUneed ? { editPost: editInUneed } : {}),
        ...(editInPersonalSite ? { editSitePost: editInPersonalSite } : {}),
      };

      if (removeFromUneed) await removePost({ pci, psi: psi[0], tp: 1 });
      if (removeFromPersonalSite) await removePost({ pci, psi: psi[0], tp: 2 });

      const rsp = await apiClient.post('/postChain/edit', {
        data: {
          ...payload,
          ...editIn,
          ...(psi ? { psi } : {}),
          ...(userSiteFilters ? { siteFilters: userSiteFilters } : {}),
          ...(siteService ? { siteService } : {}),
        },
      });

      let medias = files.filter((f) => typeof f !== 'string');
      // push 3d model file if there is any
      medias = modelFile ? [...medias, modelFile] : medias;

      if (medias.length)
        await uploadMedias({
          medias,
          ft: UPLOAD_MEDIA_FOREIGN_TYPES.POST_CHAIN,
          fi: pci,
        });

      subscriber.next({
        event: POST_CHAIN_NEW_MEDIAS_UPLOADED_SUCCESSFULLY,
        payload: medias,
      });

      if (addToUneed) await toPost({ pi: pci, ...payload });

      if (addToPersonalSite)
        await toSitePost({
          pi: pci,
          siteId,
          siteService,
          userSiteFilters,
          ...__pickBy(payload, (_, k) => k !== 'si'),
        });

      subscriber.next({
        event: POST_EDITED_SUCCESSFULLY,
        payload: rsp?.result,
      });
      subscriber.complete();
    } catch (e) {
      handleError(e.data);
      subscriber.error(e.data);
    }
  });
};
